import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { AddDeviceComponent } from './containers/add-device.component';
import { AddDeviceEffects } from './state/add-device.effects';
import * as fromAddDevice from './state/add-device.reducer';
import { AddDeviceViewComponent } from './views/add-device-view.component';
@NgModule({
   declarations: [AddDeviceComponent, AddDeviceViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      EntitySelectModule,
      LcsDatepickerModule,
      LcsAdvancedMultiSelectModule,
      StoreModule.forFeature(fromAddDevice.addDeviceFeatureKey, fromAddDevice.reducer),
      EffectsModule.forFeature([AddDeviceEffects]),
   ],
})
export class AddDeviceModule {}
